module.exports = __webpack_public_path__ + "img/zzkf.1560d865.jpg";